import { Accordion as AccordionComponent, css, mixins, styled } from '@bob/library'
import { Markdown } from '@websrc/App/Components/Markdown/Markdown'

const clearPrint = css`
  margin: 0 !important;
  padding: 0 !important;
`

export const AccordionLink = styled.a`
  ${mixins.cta.hyperlink('white')}
  & {
    display: flex;
    text-decoration: underline;
  }
  ${mixins.padding(5)}
  & > span {
    ${mixins.typography.noColor.paragraphSmall}
  }
`
export const Wrapper = styled.div`
  ${mixins.padding(20, 15)};
  background-color: ${({ theme }: { theme: any }) => theme.background.secondary};
  color: ${({ theme }: { theme: any }) => theme.color.secondary};
  @media print {
    background: none;
  }
`
export const Title = styled.h2`
  ${mixins.typography.headlineMedium};
  color: ${({ theme }: { theme: any }) => theme.color.secondary};
  ${mixins.margin.top(30)};
  ${mixins.margin.bottom(30)};
  @media print {
    ${clearPrint}
  }
`
export const ItemContent = styled.div`
  & > a,
  & > p {
    ${mixins.typography.noColor.subtitleSmall};
  }
  ${mixins.padding(10, 0)};
  @media print {
    ${clearPrint};
    & > * {
      ${clearPrint}
    }
  }
`

export const ItemLabel = styled.div`
  ${mixins.typography.subtitleSmall};
  background-color: ${({ theme }: { theme: any }) => theme.background.secondary};
  color: ${({ theme }: { theme: any }) => theme.color.secondary};
  border: none;
  ${mixins.padding(10, 0)}
  ${mixins.margin(5, 0)}
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  & > svg > path {
    fill: ${({ theme }: { theme: any }) => theme.color.secondary};
  }
  @media print {
    background: none;
  }
`
export const Accordion = styled(AccordionComponent)`
  display: flex;
  flex-direction: column;
  border-top: 1px solid ${({ theme }: { theme: any }) => theme.color.secondary};
  &:last-child {
    border-bottom: 1px solid ${({ theme }: { theme: any }) => theme.color.secondary};
  }
  // display children when print
  @media print {
    & svg {
      display: none;
    }
    & > * {
      display: block !important;
    }
  }
`

export const Content = styled(Markdown)`
  @media print {
    & > * {
      ${clearPrint}
    }
  }
`
